import { ClientOrganizerScheduleOptions, DayOfWeek } from '@st/sdk'
import { humanJoin } from '@st/util/inflect'
import { formatTimeZone } from '@st/util/time'

export function formatSchedule(
  schedule: Pick<ClientOrganizerScheduleOptions, 'daysOfWeek' | 'timesOfDay' | 'timeZone'>
) {
  return [
    'every',
    formatDays(schedule.daysOfWeek),
    'at',
    formatTimesOfDay(schedule.timesOfDay),
    formatTimeZone(schedule.timeZone)
  ].join(' ')
}

export function formatTimesOfDay(timesOfDay: string[]) {
  const times = timesOfDay.map((timeOfDay) => {
    return new Date(`2000-01-01T${timeOfDay}`).toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    })
  })
  return humanJoin(times, 'and')
}

export function formatDays(daysOfWeek: DayOfWeek[]) {
  const days = daysOfWeek.map((day) => day.charAt(0).toUpperCase() + day.slice(1))
  return humanJoin(days, 'and')
}
